<template>
  <div class="stk-py-6">
    <TaskIndex
      title="Completed Tasks"
      status="completed"
    />
  </div>
</template>

<script>
import TaskIndex from '@frontend/ui/features/tasks/components/tasks/TaskIndex.vue';

export default {
  name: 'ActionCenterCompletedView',
  components: {
    TaskIndex,
  },
};
</script>
